import { OrgSdk } from 'lib-klab-sdks';
import {
    WorkSchedule,
    WorkScheduleStatus,
    DayOfWeek,
    WorkDay,
} from '../../../domain/models/organization/work-schedule.model';

const VALID_DOW: DayOfWeek[] = [
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY',
];

function toDayOfWeek(v: any): DayOfWeek {
    return VALID_DOW.includes(v) ? v : 'MONDAY';
}

function toStatus(v: any): WorkScheduleStatus {
    return v === 'INACTIVE' ? 'INACTIVE' : 'ACTIVE';
}

function mapSDKWorkDayToDomain(d: OrgSdk.WorkDayResponse | any): WorkDay {
    return {
        id: Number(d?.workDayId ?? d?.id ?? 0),
        dayOfWeek: toDayOfWeek(d?.dayOfWeek),
        startTime: String(d?.startTime ?? ''),
        endTime: String(d?.endTime ?? ''),
        breakTime: d?.breakTime === true,
        countBreakTime: Number.isFinite(Number(d?.countBreakTime)) ? Number(d?.countBreakTime) : undefined,
    };
}

export function mapSDKWorkScheduleToDomain(
    sdk: OrgSdk.WorkScheduleResponse
): WorkSchedule {
    const dep = sdk.department ?? ({} as OrgSdk.DepartmentSummary);

    return {
        id: Number(sdk.workScheduleId ?? 0),
        name: String(sdk.name ?? ''),
        status: sdk.status === 'INACTIVE' ? 'INACTIVE' : 'ACTIVE',
        department: {
            id: Number(dep.departmentId ?? 0),
            name: String(dep.name ?? ''),
        },
        days: (sdk.days ?? []).map(mapSDKWorkDayToDomain),
    };
}